export default {
	type: 'object',
	properties: {
		project: {
			type: 'object',
			properties: {
				projectUrl: { type: 'string' },
				title: { type: 'string' },
			},
			required: ['projectUrl'],
		},
		userId: { type: 'string' },
		platformId: { type: 'string' },
	},
	required: ['project', 'userId', 'platformId'],
	additionalProperties: false,
}
